module.exports = __webpack_public_path__ + "img/team_logo_nshop.130856a5.png";